import { Text } from '@thanx/uikit/text'
import palette from 'constants/palette'
import React from 'react'
import { useStyletron } from 'styletron-react'

type Props = {
  label: string
  amount: string
  descriptor: string
}

// One of the two per-event rate cards in the activation pricing modal. Label sits
// ABOVE the amount, per the design. Border only — these carry no shadow (unlike the
// credit panel's inner tile).
const RateCard = ({ label, amount, descriptor }: Props) => {
  const [css] = useStyletron()
  return (
    <div
      className={css({
        flex: 1,
        border: `1px solid ${palette.grey20}`,
        borderRadius: '4px',
        padding: '16px',
      })}
    >
      <Text.BodyText4 tag="div" bold color="grey90">
        {label}
      </Text.BodyText4>
      <Text.Header3 tag="div" bold className="mt-xs">
        {amount}
      </Text.Header3>
      <Text.BodyText4 tag="div" color="grey70" className="mt-xxs">
        {descriptor}
      </Text.BodyText4>
    </div>
  )
}

export default RateCard
